/**
 * Chrome for MUI popup surfaces (Menu, Popover) so they match the themed
 * panels rather than MUI's default white paper.
 *
 * MUI paints `Paper` with its own background and an `backgroundImage` overlay
 * in dark mode, which shows as a pale halo around every popup. Passing this as
 * `slotProps.paper.sx` keeps popups on the `od-*` tokens instead. ContextMenu
 * spreads this and adds its own wider `minWidth`.
 */
export const menuPaperSx = {
  backgroundColor: "var(--od-surface)",
  backgroundImage: "none",
  color: "var(--od-text)",
  border: "1px solid var(--od-border)",
  borderRadius: "8px",
  boxShadow:
    "0 12px 32px -12px color-mix(in srgb, var(--od-muted) 45%, transparent)",
  py: 0.5,
};

/** Menu rows: token the text and hover so they sit on `menuPaperSx`. */
export const menuItemSx = {
  fontSize: "0.8125rem",
  color: "var(--od-text)",
  "&:hover": { backgroundColor: "var(--od-surface-2)" },
  "&.Mui-selected": {
    backgroundColor: "var(--od-surface-2)",
    "&:hover": { backgroundColor: "var(--od-surface-2)" },
  },
  "&.Mui-disabled": { color: "var(--od-muted)" },
};
